import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router'
import { Observable } from 'rxjs'
import { take, map } from 'rxjs/operators'
import { BasicAuthService } from '../services/basic-auth.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(public authService: BasicAuthService, public router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAuthenticated().pipe(
      take(1),
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true
        }
        this.router.navigate(['auth/login'], { queryParams: { returnUrl: state.url } }).then()
        return false
      }),
    )
  }
}
